import { eDmTrangThaiHocActionsObj } from "../../action-types/category/IDmTrangThaiHocActions";
import { generateActions } from "../generateActions";

export const trangThaiHocActions = {
  ...generateActions(eDmTrangThaiHocActionsObj, "TRANG_THAI_HOC"),
};
